var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/**
 * tab 列表项
 */
import ListItem, { DefaultAvatarSize } from '../../ListItem';
import React, { useCallback, useEffect, useMemo } from 'react';
import { GroupTag } from '../../Tags';
import UserSelectionContext from '../context';
import { Select } from 'antd';
import IconFont from '../../IconFont';
function TabListItemSelector(_a) {
    var itemSelectorOptions = _a.itemSelectorOptions, onSelectChange = _a.onSelectChange;
    var onChange = useCallback(function (value) {
        onSelectChange(value);
    }, [onSelectChange]);
    if (!itemSelectorOptions || itemSelectorOptions.length === 0) {
        return null;
    }
    return (React.createElement(Select, { defaultValue: itemSelectorOptions[0].value, bordered: false, size: "small", onChange: onChange, dropdownClassName: "list-item-selector", suffixIcon: React.createElement(IconFont, { type: "iconlog_down" }) }, itemSelectorOptions.map(function (item, index) {
        return (React.createElement(Select.Option, { key: index, value: item.value }, item.label));
    })));
}
export default function TabPaneListItem(props) {
    var _a = React.useContext(UserSelectionContext), onGetAvatarURL = _a.onGetAvatarURL, currentUser = _a.currentUser, t = _a.t;
    var data = props.data, onClick = props.onClick, hasItemSelector = props.hasItemSelector, onItemDelete = props.onItemDelete, rightExtra = props.rightExtra, itemSelectorOptions = props.itemSelectorOptions, onChangeItem = props.onChangeItem, onChangeDataAll = props.onChangeDataAll, rest = __rest(props, ["data", "onClick", "hasItemSelector", "onItemDelete", "rightExtra", "itemSelectorOptions", "onChangeItem", "onChangeDataAll"]);
    var avatar = data.avatar, isGroup = data.isGroup, kind = data.kind, subKind = data.subKind, id = data.id, isDept = data.isDept, business = data.business, ext = data.ext;
    var itemData = __assign(__assign({}, data), (onGetAvatarURL && typeof avatar === 'string'
        ? {
            avatar: onGetAvatarURL(avatar, DefaultAvatarSize, DefaultAvatarSize),
        }
        : {}));
    // const tag = isDept ? null : isGroup ? (
    //     <GroupTag business={business} kind={kind} ext={ext} subKind={subKind} t={t} />
    // ) : (
    //     <ContactsTag userI={currentUser} userII={parseUidFromString(id)} t={t} />
    // );
    var tag = isGroup ? (React.createElement(GroupTag, { business: business, kind: kind, ext: ext, subKind: subKind, t: t })) : null;
    useEffect(function () {
        if (hasItemSelector && itemSelectorOptions) {
            data.selectedValue = itemSelectorOptions[0].value;
        }
    }, [data, hasItemSelector, itemSelectorOptions]);
    var selectorCallback = useCallback(function (value) {
        Object.assign(data, { selectedValue: value });
    }, [data]);
    var selector = useMemo(function () {
        if (!hasItemSelector || !itemSelectorOptions || itemSelectorOptions.length === 0) {
            return null;
        }
        return (React.createElement(TabListItemSelector, { itemSelectorOptions: itemSelectorOptions, onSelectChange: selectorCallback }));
    }, [hasItemSelector, itemSelectorOptions, selectorCallback]);
    return (React.createElement(ListItem, __assign({ data: itemData, onClick: function () {
            if (onClick) {
                onClick(data);
            }
        } }, rest, { tag: tag, selector: selector, rightExtra: rightExtra, onItemDelete: function () {
            if (onItemDelete) {
                onItemDelete(data);
            }
        }, onChangeItem: onChangeItem, onChangeDataAll: onChangeDataAll })));
}
//# sourceMappingURL=TabPaneListItem.js.map